export default "__VITE_ASSET__6D_KfsA5__"